import { render, staticRenderFns } from "./GtyPopup.vue?vue&type=template&id=931268b6&scoped=true"
import script from "./GtyPopup.vue?vue&type=script&lang=js"
export * from "./GtyPopup.vue?vue&type=script&lang=js"
import style0 from "./GtyPopup.vue?vue&type=style&index=0&id=931268b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931268b6",
  null
  
)

export default component.exports